export default __webpack_public_path__ + "static/media/Group 27102.8dba1a1c.svg";